window.addEventListener("load", function () {
  // ラベル要素をチェック
  const labelProduct = document.querySelector(
    ".product-rerender .label-product"
  );

  // 画像アプリ要素を取得
  const galleryWrapper = document.querySelector(".product-gallery-wrapper");

  if (labelProduct && galleryWrapper) {
    galleryWrapper.appendChild(labelProduct);
    labelProduct.classList.add("show-label");
  }
});
